import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

// Const
import { ROOM_ONLINE, ROOM_AFK } from '../../../const';
import { firestore } from '../../../lib/firebase';

const styles = () =>
	({
		root :
		{
			width          : '100%',
			justifyContent : 'center',
			alignItems     : 'center',
			display        : 'flex',
			flexDirection  : 'column'
		},
		statusInfo :
		{
			marginTop      : '15%',
			width          : '100%',
			justifyContent : 'center',
			alignItems     : 'center',
			display        : 'flex',
			flexDirection  : 'column'
		},
		statusLogo :
		{
			height       : '5rem',
			marginBottom : '1rem'
		},
		statusMessage :
		{
			fontSize     : '1.5rem',
			fontWeight   : '200',
			color        : '#adadac',
			marginBottom : '1rem'
		},
		statusControl :
		{
			width          : '12rem',
			display        : 'flex',
			justifyContent : 'space-between'
		},
		statusControlBtn :
		{
			width           : '5rem',
			height          : '5rem',
			borderRadius    : '5rem',
			fontSize        : '1rem',
			backgroundColor : 'white',
			color           : '#adadac',
			boxShadow       : '2px 2px 4px #aaa',
			'&:hover'       :
				{
					backgroundColor : '#f50057'
				}
		},
		statusControlBtnActive :
		{
			backgroundColor : '#9ec317',
			color           : 'white',
			boxShadow       : '2px 2px 4px inset #aaa'
		},
		roomStatus :
		{
			marginTop : '0%'
		},
		roomStatusInfo :
		{
			fontSize : '0.9rem',
			width    : '100%',
			color    : '#e26b04'
		}
	});

const StatusView = ({
	classes,
	room,
	roomsStatus
}) =>
{
	const updateStatus = useCallback((status) =>
	{
		if (room && room.name)
		{
			firestore.collection('rooms').doc(room.name)
				.update(
					{
						status : status
					}
				);
		}
	}, [ room ]);

	return (
		<div className={classes.root}>

			<div className={classes.roomStatus}>
				<Typography className={classes.roomStatusInfo}>
					待機中 {roomsStatus?.waitingRooms} 人
					&nbsp;&nbsp;&nbsp;
					通話中 {roomsStatus?.callingRooms} 人
				</Typography>
			</div>
			{room.info &&
			<div className={classes.statusInfo}>
				{ room.info.status === ROOM_ONLINE?
					<img
						alt='status'
						src='images/status_waiting.png'
						className={classes.statusLogo}
					/>
					:
					<img
						alt='status'
						src='images/status_afk.png'
						className={classes.statusLogo}
					/>
				}
				<div className={classes.statusMessage}>
					{ room.info.status === ROOM_ONLINE ?
						'現在待機中です'
						:
						'現在離席中です'
					}
				</div>
				<div className={classes.statusControl}>
					<Button
						className={classnames(
							classes.statusControlBtn,
							room.info.status === ROOM_AFK ? classes.statusControlBtnActive : null
						)}
						onClick={() => updateStatus(ROOM_AFK)}
					>
						離席
					</Button>
					<Button
						className={classnames(
							classes.statusControlBtn,
							room.info.status === ROOM_ONLINE ? classes.statusControlBtnActive : null
						)}
						onClick={() => updateStatus(ROOM_ONLINE)}
					>
						待機
					</Button>
				</div>
			</div>
			}
		</div>
	);

};

StatusView.propTypes =
{
	room        : PropTypes.object.isRequired,
	classes     : PropTypes.object.isRequired,
	roomsStatus : PropTypes.object.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room : state.room
	};
};

const mapDispatchToProps = () =>
{
	return {
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room
			);
		}
	}
)(withStyles(styles)(StatusView)));
